interface headerItem {
    dataElement?: string
}
function getHeaderItem(
    headerItems: Array<headerItem>,
    dataElementToFind: string,
) {
    const item = headerItems.find(
        ({ dataElement }: headerItem) => dataElement === dataElementToFind,
    )

    if (!item) {
        throw new Error(`Header item ${dataElementToFind} not found`)
    }
    return item
}

const zoomArray = [
    25, 33, 50, 67, 75, 80, 90, 100, 110, 125, 150, 175, 200, 250, 300, 400,
    500, 800, 1600, 6400,
]
const zoomArrayLength = zoomArray.length
const closestMatch = (array: number[], searchKey: number) => {
    return array.reduce((previousNum, currentNum) => {
        const previousDiff = Math.abs(previousNum - searchKey)
        const currentDiff = Math.abs(currentNum - searchKey)

        if (previousDiff == currentDiff) {
            return previousNum > currentNum ? previousNum : currentNum
        } else {
            return currentDiff < previousDiff ? currentNum : previousNum
        }
    })
}

function zoomIn(instance: any) {
    {
        const currentZoom = instance?.docViewer.getPageZoom(1) || 1
        const closestZoom = closestMatch(zoomArray, Number(currentZoom * 100))
        const currentIndex = zoomArray.findIndex(value => value === closestZoom)
        const newIndex =
            currentIndex === zoomArrayLength - 1
                ? currentIndex
                : currentIndex + 1

        return instance?.docViewer.zoomTo(zoomArray[newIndex] / 100)
    }
}

function zoomOut(instance: any) {
    const currentZoom = instance?.docViewer.getPageZoom(1) || 1
    const closestZoom = closestMatch(zoomArray, Number(currentZoom * 100))
    const currentIndex = zoomArray.findIndex(value => value === closestZoom)
    const newIndex = currentIndex === 0 ? currentIndex : currentIndex - 1

    return instance?.docViewer.zoomTo(zoomArray[newIndex] / 100)
}

export { getHeaderItem, zoomIn, zoomOut }
